import { render, staticRenderFns } from "./CampanhaProducao.vue?vue&type=template&id=cc5d289a&scoped=true"
import script from "./CampanhaProducao.vue?vue&type=script&lang=js"
export * from "./CampanhaProducao.vue?vue&type=script&lang=js"
import style0 from "./CampanhaProducao.vue?vue&type=style&index=0&id=cc5d289a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5d289a",
  null
  
)

export default component.exports